const minTommss = minutes => {
  const sign = minutes < 0 ? '-' : ''
  const min = Math.floor(Math.abs(minutes))
  const sec = Math.floor((Math.abs(minutes) * 60) % 60)
  return `${sign}${min < 10 ? '0' : ''}${min}:${sec < 10 ? '0' : ''}${sec}`
}

export default minTommss
